module.exports = __webpack_public_path__ + "static/media/undraw_teacher.597f57fe.svg";